import { useState } from 'react'
import { ArrowRight, Check, TriangleAlert } from 'lucide-react'

import { cn } from '@/utilities/ui'

import { ProfileStepStatus } from './profileStepCompletion'

const stepStatusStyles: Record<ProfileStepStatus, { container: string; icon: string }> = {
  incomplete: {
    container: 'bg-neutral-300 rounded-full p-2 self-end',
    icon: 'size-3 text-primary',
  },
  inProgress: {
    container: 'bg-amber-100 rounded-full p-2 self-end',
    icon: 'size-3 text-amber-600',
  },
  completed: {
    container: 'bg-accent rounded-full p-2 self-end',
    icon: 'size-3 text-primary-foreground',
  },
}

export const ProfileStepButton = ({
  title,
  description,
  onClick,
  isActive,
  status,
}: {
  title: string
  description: string
  onClick: () => void
  isActive: boolean
  status: ProfileStepStatus
}) => {
  const styles = stepStatusStyles[status]
  const activeOverride = isActive && status !== 'completed'
  const [hover, setHover] = useState(false)
  return (
    <button
      className={cn(
        'flex w-full cursor-pointer items-center justify-between rounded-xl border border-border px-6 py-4 text-primary',
        hover && 'border-accent bg-accent text-primary-foreground',
      )}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div>
        <h3 className="text-left font-family-display text-xl">{title}</h3>
        <p className="text-left font-family-body text-sm">{description}</p>
      </div>
      {status === 'completed' ? (
        <div className={cn(!hover ? styles.container : 'self-end rounded-full bg-neutral-300 p-2')}>
          <Check
            className={cn(!hover ? 'size-3 text-primary-foreground' : 'size-3 text-primary')}
          />
        </div>
      ) : status === 'inProgress' ? (
        <div className={cn(styles.container, activeOverride && 'bg-amber-200')}>
          <TriangleAlert
            className={cn('size-3', styles.icon, activeOverride && 'text-amber-700')}
          />
        </div>
      ) : (
        <div
          className={cn(
            'self-end rounded-full bg-neutral-300 p-2',
            hover && 'bg-neutral-200 text-primary-foreground',
          )}
        >
          <ArrowRight className={cn('size-3 text-primary')} />
        </div>
      )}
    </button>
  )
}
